import React, {useState, useEffect, useRef, useCallback } from 'react'
import Chart, { Grid as GridChart, CommonSeriesSettings, ArgumentAxis, Series, Legend, ValueAxis, ZoomAndPan, ScrollBar, Tooltip, TickInterval, Aggregation, Point, Title, AggregationInterval, Label, Height, Crosshair, Font, MinorTickInterval, Tick, MinorTick, Strip, CommonAxisSettings } from 'devextreme-react/chart';
import CardHeader from "components/Card/CardHeader.js";
import RangeSelector, {
    Size, Chart as ChartOptions, Margin, Scale, Behavior, RangeSelectorTypes,
} from 'devextreme-react/range-selector';
import moment from 'moment'
import { Grid } from '@mui/material';
import DateRange from '../../components/Dates/DateRange';
import { TextField, Chip, Button, Select, MenuItem, Checkbox } from "@mui/material"
interface GraphData {
    date: Date;
    flowRate: number
}
interface Props {
    serial: number
}


const MinimumNightFlow: React.FC<Props> = (serial) => {

    const chartRef = useRef(null)
    const [graphData, setGraphData] = useState<GraphData>([])
    const [startDate, setStartDate] = useState<Date>(moment().subtract(365, 'days'))
    const [endDate, setEnddate] = useState<Date>(moment())
    useEffect(() => {
        generateFlowRateData()
    }, [])
    // Function to generate mock data for flow rate over the past year
    const generateFlowRateData = () => {
        const data = [];
        const daysInYear = 365;

        // Define the start of the spike and subsequent gradual increase
        const spikeStartIndex = Math.floor(Math.random() * (daysInYear - 40)) + 1; // Randomly positioned spike

        for (let i = 0; i <= daysInYear; i++) {
            // Create a date for each day, starting from 1 year ago and adding `i` days
            const date = moment().subtract(1, 'year').add(i, 'days');

            let flowRate;

            if (i === spikeStartIndex) {
                // Abrupt initial spike to around 4 L/s
                flowRate = 4 + (Math.random() * 0.2 - 0.1);
            } else if (i > spikeStartIndex && i <= spikeStartIndex + 35) {
                // Gradually increase from the initial spike, staying above 4 L/s
                const gradualIncrease = 4 + (i - spikeStartIndex) * 0.05; // Small increment each day
                flowRate = gradualIncrease + (Math.random() * 0.1 - 0.05); // Small random fluctuation
            } else if (i === spikeStartIndex + 36) {
                // Abrupt drop back to around 2 L/s
                flowRate = 2 + (Math.random() * 0.2 - 0.1);
            } else {
                // Normal data around 2 L/s
                flowRate = 2 + (Math.random() * 0.2 - 0.1);
            }

            // Add the data point to the array
            data.push({
                date: date.format('DD MMM'),  // Format the date as a string
                flowRate: parseFloat(flowRate.toFixed(2))
            });
        }

        // Sort the data by date to ensure chronological order
        data.sort((a, b) => moment(a.date).diff(moment(b.date)));

        // Update the graph with the data
        setGraphData(data);
    };




    const renderToolTip = (point) => {
        console.log(point)
        return (
            <div>
                <p>{`Value: ${point.point.data.flowRate} l/s`}</p>
                <p>{`Date: ${moment(point.point.data.date).format("DD-MM-yyyy hh:mm:ss A")}`}</p>
            </div>
        )
    }

  
    const onDateChange = (startDateChange: moment, endDateChange: moment, rainfall) => {
        console.log(startDateChange)
    }

    const resetZoom = useCallback(() => {
        chartRef.current.instance().resetVisualRange();

    }, []);

    const customArgument = ( date ) => {
        console.log(date)
        return moment(date).format('dd:MM')
    }

    return (
        <div>
            {graphData.length > 0 && <div>
                {console.log(graphData) }
                <CardHeader color="primary" className="view view-cascade" style={{ paddingTop: "50px" }}>
                <Grid container  >
                        <Grid item lg={12}  >
                            <div style={{display: "flex", float: "right", marginBottom: "10px"} }>
                            <Button variant="contained" color="secondary" style={{ marginRight: "10px" }} onClick={resetZoom}>Reset Zoom</Button>
                            <Button variant="contained" color="primary" style={{ marginRight: "10px" }}>Edit Graph Settings</Button>
                        </div>
                        <DateRange startDate={graphData[0].date} endDate={graphData[graphData.length -1].date} rainfall={false} onDateChange={(startDateChange, endDateChange, rainfall): void => onDateChange(startDateChange, endDateChange, rainfall)} type="date" />
                    </Grid>
                </Grid>
                </CardHeader>
                <div style={{marginTop: "30px"} }>
                <Chart dataSource={graphData} ref={chartRef }>
                            <CommonSeriesSettings
                                argumentField="date"
                                ignoreEmptyPoints={true}>
                                <Point size={15} />
                                <Font weight={900} size={40} />
                            </CommonSeriesSettings>
                            <Series valueField={"flowRate"} color={'#0000ff'} type={'bar'} axis={'flowRate' } /> 
                            <ValueAxis
                                width={2}
                                name={'flowRate'}
                                color={"#0000ff"}
                                title={{ text: `Minimum Night Flow for ${serial.serial}`, font: { color: '#0000ff', size: 12 } }}
                            >
                                <Label font={{color: "#0000ff"} } />
                        </ValueAxis>
                        <ArgumentAxis
                            width={2}
                            allowDecimals={false}
                            argumentType="date"
                            minValueMargin={0}
                            maxValueMargin={0}
                            aggregationInterval="day"
                        //visualRange={visualRange}
                        >
                            <GridChart visible={true} />
                        </ArgumentAxis>
                            <Legend
                                visible={false}
                            />
                            
                            <Crosshair
                                enabled={true}
                                color="#949494"
                                width={3}
                                dashStyle="dot"
                            >
                                <Label
                                    visible={true}
                                    backgroundColor="#949494"
                                >
                                    <Font
                                        color="#fff"
                                        size={14}
                                    />
                                </Label>
                            </Crosshair>
                            <ZoomAndPan
                                allowMouseWheel={false}
                                argumentAxis="both"
                                valueAxis="none"
                                dragToZoom={true}
                            />
                            <Tooltip enabled={true} contentRender={renderToolTip} />
                    </Chart>
                        </div>

            
            <div style={{ marginTop: "40px" }}>
                <CardHeader color="primary">
                    <h4 style={{ display: "flex", justifyContent: "center" }}>Adjust the range to zoom and drag to move the range on the graph</h4>
                    {graphData.length > 0 && <RangeSelector
                        dataSource={graphData}
                        //onValueChanged={updateVisualRange}
                        style={{ background: "#ffffff", margin: "10px", padding: "10px" }}
                    >
                        <Behavior valueChangeMode="onHandleMove" />
                        <Size height={150} />
                        <Scale minorTickCount={1} startValue={graphData[0].date} endValue={graphData[graphData.length - 1].date} />
                        <ChartOptions>
                            <Legend visible={false} />
                            <Series
                                argumentField="date"
                                valueField={`flowRate`}
                                color={'#0000ff'}
                                key={`${serial.serial}`}
                                type={'spline'}
                            />
                        </ChartOptions>
                    </RangeSelector>}
                </CardHeader>
                </div>
            </div>}
        </div>
    )
}

export default MinimumNightFlow